import { AxiosError } from "axios";

export class HttpError extends Error {
  readonly statusCode: number;
  readonly data: unknown;

  constructor(axiosError: AxiosError) {
    super(HttpError.resolveMessage(axiosError));
    this.name = "HttpError";
    this.statusCode = axiosError.response?.status ?? 0;
    this.data = axiosError.response?.data;
  }

  private static resolveMessage(axiosError: AxiosError): string {
    const data = axiosError.response?.data as { message?: string } | undefined;
    return data?.message ?? axiosError.message ?? "Request failed";
  }
}
